$(document).ready(function () {
  $(document).on("click", ".bundle-product-add-to-cart", function () {
    var activeLength = $(".bundle-product-add-to-cart.active").length;
    var prodLimit = $("html").attr("bundle-product-limit");
    var remainingCount = Number(prodLimit)-(activeLength+1);
    $('.main-counter').html(`0${activeLength+1}`);
    $('.custom-page-left .added-item-count').html(remainingCount);
    if (activeLength < prodLimit) {
      $(this).addClass("active");
      $(this).hide();
      $(this).next().show();
    }
    if (activeLength == prodLimit - 1) {
      $(this).addClass("active");
      $(this).hide();
      $(this).next().show();
      $("#product-grid .bundle-product-add-to-cart").prop("disabled", true);
      $('.custom-page-left').hide();
      $('.ajax-add-bundle').prop("disabled", false);

      var ccou = 0; 
      $(".bundle-product-add-to-cart.active").each(function(){
        var orgprice = $(this).attr("data-price");
        ccou += parseFloat(orgprice);   
        });
        var mprice = ccou - parseFloat($(".main_product_price").val());
        var fmt = $(".money-format-cstm").val();
        var ogfmt = fmt.replace(" 0.00"," "+mprice.toFixed(2));
        $(".custom-page-compare span").text(ogfmt);
        $('.custom-page-compare').show();
      }
  });
  
  $(document).on('click','.remove-bundle-product',function(){
    $('.custom-page-compare').hide();
    var activeLength = $(".bundle-product-add-to-cart.active").length;
    var prodLimit = $("html").attr("bundle-product-limit");
    var remainingCount = Number(prodLimit)-(activeLength-1)
    if(activeLength < prodLimit){
        $('.main-counter').html(`0${activeLength-1}`);
        $('.custom-page-left .added-item-count').html(remainingCount);
        $('.ajax-add-bundle').prop("disabled", true);
    }
    if(activeLength == prodLimit){
        $('.custom-page-left').show();
        $('.main-counter').html(`0${activeLength-1}`);
        $('.custom-page-left .added-item-count').html(remainingCount);
        $('.ajax-add-bundle').prop("disabled", true);
    }
    $(this).hide();
    $(this).prev().show();
    $(this).prev().removeClass('active');
    $("#product-grid .bundle-product-add-to-cart").prop("disabled", false);
  });

  $(document).on("click",".ajax-add-bundle",function(){
  var vvid = $(".ajax-add-bundle").attr("data-id");
  var jsonobj = [];
  var item= {};
  
  item['id'] = vvid;
  var itemobj={};
  var  i = 1;
  $(".bundle-product-add-to-cart.active").each(function(){
  var names = $(this).attr("product-name");
  var keyname = "item "+i;    
  itemobj[keyname] = names;
   i++;   
  });
  console.log(itemobj);  
  item['properties'] = itemobj; 
  jsonobj.push(item);
  
  $.ajax({
        type: "POST", 
        url: '/cart/add.js',
        data: {items: jsonobj },
        dataType: "json",
        success: function(response) {
          console.log(response)
          console.log(1)
            $("#mini-cart").load(location.href + " #mini-cart");
            $("#cart-icon-bubble").load(location.href + " #cart-icon-bubble");
            setTimeout(function () {
                $(".cart-drawer-container").addClass("menu-opening");
                $(".cart-drawer-container").attr("open", true);
                $("body").addClass("mini-cart--open");   
            },1000);
        },
        error: function (error) {
          console.log(error)
        }
      });
  });

  

  // function setCookie(cname, cvalue, exdays) {
  //   const d = new Date();
  //   d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  //   let expires = "expires=" + d.toUTCString();
  //   document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  // }

  // function getCookie(cname) {
  //   let name = cname + "=";
  //   let ca = document.cookie.split(";");
  //   for (let i = 0; i < ca.length; i++) {
  //     let c = ca[i];
  //     while (c.charAt(0) == " ") {
  //       c = c.substring(1);
  //     }
  //     if (c.indexOf(name) == 0) {
  //       return c.substring(name.length, c.length);
  //     }
  //   }
  //   return "";
  // }

  // function delete_cookie(name) {
  //   document.cookie =
  //     name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  // }

  // function isVariantAvailableInCart(productID, callback) {
  //   $.ajax({
  //     type: "GET",
  //     url: "/cart.js", // Shopify's cart endpoint
  //     dataType: "json",
  //     success: function (cart) {
  //       console.log(cart);
  //       // Loop through the cart items and check if the product is already in the cart
  //       var isInCart = false;
  //       for (var i = 0; i < cart.items.length; i++) {
  //         if (cart.items[i].id == productID) {
  //           isInCart = true;
  //           break;
  //         }
  //       }

  //       // Call the callback function with the result
  //       callback(isInCart);
  //     },
  //   });
  // }
  function checkAddToCartButton() {
    $(`.bundle-product-add-to-cart`).prop("disabled", false);
    $(`.bundle-product-add-to-cart`).html("Add to cart");
    var prodLimit = $("html").attr("bundle-product-limit");
    var json_getAddedItem = getCookie("addedItem");
    if (json_getAddedItem == "") {
      var addedItem = [];
    } else {
      var getAddedItem = JSON.parse(json_getAddedItem);
      var addedItem = getAddedItem;

      addedItem.map((data) => {
        $(`.bundle-product-add-to-cart[data-id="${data}"]`).prop(
          "disabled",
          true
        );
        $(`.bundle-product-add-to-cart[data-id="${data}"]`).html("Added");
      });
    }
    if (addedItem.length >= prodLimit) {
      $("#product-grid .bundle-product-add-to-cart").prop("disabled", true);
    }
  }

  function removeCartItem() {
    $.ajax({
      type: "GET",
      url: "/cart.js", // Shopify's cart endpoint
      dataType: "json",
      success: function (cart) {
        var json_getAddedItem = getCookie("addedItem");
        if (json_getAddedItem != "") {
          var newArr = [];
          for (var i = 0; i < cart.items.length; i++) {
            var getAddedItem = JSON.parse(json_getAddedItem);
            var addedItem = getAddedItem;

            addedItem.map((data) => {
              if (cart.items[i].id == data) {
                newArr.push(data);
              }
            });
          }
          delete_cookie("addedItem");
          var json_addedItem = JSON.stringify(newArr);
          setCookie("addedItem", json_addedItem, 1);
        }
        checkAddToCartButton();
      },
    });
  }
  $(document).on("click", ".delete-product", function () {
    setTimeout(function () {
      removeCartItem();
    }, 1500);
  });
  $(document).on(
    "click",
    "cart-remove-button a.button.button--tertiary",
    function () {
      setTimeout(function () {
        removeCartItem();
        $("#main-cart-footer").load(location.href + " #main-cart-footer");
      }, 1000);
    }
  );
  checkAddToCartButton();
  // $(document).on("click", ".bundle-product-add-to-cart", function () {
  //   var json_getAddedItem = getCookie("addedItem");
  //   if (json_getAddedItem == "") {
  //     var addedItem = [];
  //   } else {
  //     var getAddedItem = JSON.parse(json_getAddedItem);
  //     var addedItem = getAddedItem;
  //   }

  //   $(".loader").hide();
  //   $(".check-item-in-cart").css("display", "none");
  //   var prodLimit = $("html").attr("bundle-product-limit");
  //   var ID = $(this).attr("data-id");
  //   var element = $(this);
  //   isVariantAvailableInCart(ID, function (result) {
  //     if (result) {
  //       element.next().css("display", "block");
  //     } else {
  //       element.css("display", "none");
  //       element.prev().show();
  //       $.ajax({
  //         type: "POST",
  //         url: "/cart/add.js",
  //         data: {
  //           quantity: 1,
  //           id: ID,
  //           properties: {
  //             _bundleProduct: "bundle",
  //           },
  //         },
  //         dataType: "json",
  //         success: function (data) {
  //           $("#mini-cart").load(location.href + " #mini-cart");
  //           $("#cart-icon-bubble").load(location.href + " #cart-icon-bubble");
  //           setTimeout(function () {
  //             addedItem.push(ID);
  //             json_addedItem = JSON.stringify(addedItem);
  //             setCookie("addedItem", json_addedItem, 1);
  //             element.prop("disabled", true);
  //             element.html("Added");
  //             $(".cart-drawer-container").addClass("menu-opening");
  //             $(".cart-drawer-container").attr("open", true);
  //             $("body").addClass("mini-cart--open");

  //             if (addedItem.length >= prodLimit) {
  //               $("#product-grid .bundle-product-add-to-cart").prop(
  //                 "disabled",
  //                 true
  //               );
  //             }
  //           }, 1000);
  //           element.css("display", "block");
  //           element.prev().hide();
  //         },
  //       });
  //     }
  //   });
  // });
});
